export const imageFilter = function (el) {
    el.querySelectorAll(".apply-filter").forEach(function (el) {
        const layerColor = document.createElement("div");
        layerColor.classList.add("layer", "layer--color");
        el.appendChild(layerColor);
        el.classList.add("has-filter");
    });

    el.querySelectorAll("iframe, img").forEach(function (item) {
        if (
            !item.parentNode.classList.contains("apply-filter") &&
            !item.classList.contains("svg")
        ) {
            const wrapper = document.createElement("div");
            wrapper.classList.add("apply-filter");
            item.insertAdjacentElement("afterend", wrapper);
            wrapper.appendChild(item);
            const layerColor = document.createElement("div");
            layerColor.classList.add("layer", "layer--color");
            wrapper.appendChild(layerColor);
            wrapper.classList.add("has-filter");

        }
    });
};
